/* Friends of Dennis Recreation — small behaviours for the fodr-* sections.
   Everything works without this file; it only keeps the bib number, the
   countdown and the phone donate bar in sync. */
(function () {
  if (window.__fodrInit) return;
  window.__fodrInit = true;

  function syncBib(bib, bump) {
    var input = bib.querySelector('[data-fodr-tier]:checked');
    if (!input) return;
    var amount = bib.querySelector('[data-fodr-amount]');
    var caption = bib.querySelector('[data-fodr-caption]');
    var button = bib.querySelector('[data-fodr-submit]');
    if (amount) {
      amount.textContent = input.dataset.label;
      if (bump) {
        amount.classList.add('is-bump');
        setTimeout(function () { amount.classList.remove('is-bump'); }, 180);
      }
    }
    if (caption) caption.textContent = input.dataset.caption || caption.dataset.default || '';
    if (button) button.textContent = (button.dataset.verb || 'Donate') + ' ' + input.dataset.label;
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-fodr-tier]');
    if (input) syncBib(input.closest('[data-fodr-bib]'), true);
  });

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tickCount(el) {
    var start = Date.parse(el.dataset.start);
    var end = Date.parse(el.dataset.end || '') || start + 4 * 3600 * 1000;
    if (isNaN(start)) { el.hidden = true; return false; }
    var now = Date.now();
    var cells = el.querySelector('[data-fodr-count-cells]');
    var live = el.querySelector('[data-fodr-count-live]');
    var label = el.querySelector('[data-fodr-count-label]');
    if (now >= end) { el.hidden = true; return false; }
    el.hidden = false;
    if (now >= start) {
      if (cells) cells.hidden = true;
      if (label) label.hidden = true;
      if (live) live.hidden = false;
      return true;
    }
    var s = Math.floor((start - now) / 1000);
    var parts = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
    Object.keys(parts).forEach(function (key) {
      var node = el.querySelector('[data-u="' + key + '"]');
      if (node) node.textContent = key === 'd' ? parts[key] : pad(parts[key]);
    });
    return true;
  }

  var timer = null;
  function initCounts() {
    var counts = [].slice.call(document.querySelectorAll('[data-fodr-count]'));
    if (timer) clearInterval(timer);
    if (!counts.length) return;
    var run = function () { counts.forEach(tickCount); };
    run();
    timer = setInterval(run, 1000);
  }

  function initSticky() {
    var bar = document.querySelector('[data-fodr-sticky]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var bibsInView = 0;
    var update = function () {
      bar.classList.toggle('is-on', window.scrollY > 500 && bibsInView === 0);
    };
    if ('IntersectionObserver' in window) {
      var seen = new Map();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        bibsInView = 0;
        seen.forEach(function (v) { if (v) bibsInView++; });
        update();
      }, { threshold: 0.25 });
      document.querySelectorAll('[data-fodr-bib]').forEach(function (b) { io.observe(b); });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // Keep the header on one line: if the links overflow, hide the social icons, then switch to the Menu button.
  function fitHeader() {
    document.querySelectorAll('[data-fodr-top]').forEach(function (top) {
      var nav = top.querySelector('.fodr-top__nav');
      var row = top.querySelector('.fodr-top__row');
      if (!nav || !row) return;
      top.classList.remove('is-compact', 'is-tight');
      if (getComputedStyle(nav).display === 'none') return;
      var overflows = function () { return nav.scrollWidth > nav.clientWidth + 1 || row.scrollWidth > row.clientWidth + 1; };
      // Drop the social icons first; only fall back to the Menu button if it still doesn't fit.
      if (overflows()) top.classList.add('is-tight');
      if (overflows()) top.classList.add('is-compact');
    });
  }
  var fitTimer = null;
  window.addEventListener('resize', function () { clearTimeout(fitTimer); fitTimer = setTimeout(fitHeader, 80); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeader);

  // Sticky header: hide while scrolling down, show on scroll up, when scrolling stops, or near the top.
  function initHeaderHide() {
    var top = document.querySelector('.fodr-top--sticky');
    var wrap = top && top.closest('.fodr-header-wrap');
    if (!wrap || wrap.dataset.hideReady) return;
    wrap.dataset.hideReady = '1';
    var lastY = window.scrollY;
    var idle = null;
    var show = function () { wrap.classList.remove('is-hidden'); };
    window.addEventListener('scroll', function () {
      var y = Math.max(0, window.scrollY);
      clearTimeout(idle);
      idle = setTimeout(show, 600);
      if (y <= wrap.offsetHeight || wrap.querySelector('details[open]') || wrap.contains(document.activeElement)) { show(); lastY = y; return; }
      if (Math.abs(y - lastY) < 6) return;
      wrap.classList.toggle('is-hidden', y > lastY);
      lastY = y;
    }, { passive: true });
  }

  function boot() {
    fitHeader();
    initHeaderHide();
    document.querySelectorAll('[data-fodr-bib]').forEach(function (b) { syncBib(b, false); });
    initCounts();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
